import { rest } from 'utils';

export default {
  postgresql: {
    getAll: () => rest.get({ baseUrl: 'database', url: '/postgresql/clusters' }),
    create: ({ properties }) => rest.post({ baseUrl: 'database', url: '/postgresql/clusters', body: { properties } }),
    get: ({ id }) => rest.get({ baseUrl: 'database', url: `/postgresql/clusters/${id}` }),
    getUpgradableVersions: ({ clusterId }) => rest.get({ baseUrl: 'database', url: `/postgresql/clusters/${clusterId}/postgresversions` }),
    getAllVersions: () => rest.get({ baseUrl: 'database', url: '/postgresql/clusters/postgresversions' }),
    update: ({ id, properties }) => rest.patch({ baseUrl: 'database', url: `/postgresql/clusters/${id}`, body: { properties } }),
    delete: ({ id }) => rest.delete({ baseUrl: 'database', url: `/postgresql/clusters/${id}` }),

    // Backups
    getAllBackups: () => rest.get({ baseUrl: 'database', url: '/postgresql/clusters/backups' }),
    getAllBackupsByClusterId: ({ clusterId }) => rest.get({ baseUrl: 'database', url: `/postgresql/clusters/${clusterId}/backups` }),
    getBackupById: ({ backupId }) => rest.get({ baseUrl: 'database', url: `/postgresql/clusters/backups/${backupId}` }),

    // Restore
    restoreBackup: ({ clusterId, properties }) => (
      rest.post({ baseUrl: 'database', url: `/postgresql/clusters/${clusterId}/restore`, body: properties })
    ),
  },
  mongodb: {
    getAll: () => rest.get({ baseUrl: 'database', url: '/mongodb/clusters' }),
    create: ({ properties }) => rest.post({ baseUrl: 'database', url: '/mongodb/clusters', body: { properties } }),
    update: ({ id, properties }) => rest.patch({ baseUrl: 'database', url: `/mongodb/clusters/${id}`, body: { properties } }),
    get: ({ id }) => rest.get({ baseUrl: 'database', url: `/mongodb/clusters/${id}` }),
    // update: ({ id, properties }) => rest.patch({ baseUrl: 'database', url: `/mongodb/clusters/${id}`, body: { properties } }),
    delete: ({ id }) => rest.delete({ baseUrl: 'database', url: `/mongodb/clusters/${id}` }),
    getTemplates: () => rest.get({ baseUrl: 'database', url: '/mongodb/templates' }),
    getAllVersions: () => rest.get({ baseUrl: 'database', url: '/mongodb/infos/versions' }),
    getUsersForCluster: (clusterId) => rest.get({ baseUrl: 'database', url: `/mongodb/clusters/${clusterId}/users` }),
    createUserForCluster: (clusterId, properties) => rest.post({ baseUrl: 'database', url: `/mongodb/clusters/${clusterId}/users`, body: { properties } }),
    deleteMongoDBUser: ({ clusterId, username }) => rest.delete({ baseUrl: 'database', url: `/mongodb/clusters/${clusterId}/users/${username}` }),
    getSnapshotsForCluster: ({ clusterId }) => rest.get({ baseUrl: 'database', url: `/mongodb/clusters/${clusterId}/snapshots` }),
    restoreCluster: ({ clusterId, snapshotId, recoveryTargetTime }) => rest
      .post({ baseUrl: 'database', url: `/mongodb/clusters/${clusterId}/restore`, body: { snapshotId, recoveryTargetTime } }),
    updateUserForCluster: ({
      clusterId,
      username,
      properties,
    }) => rest.patch({ baseUrl: 'database', url: `/mongodb/clusters/${clusterId}/users/${username}`, body: { properties } }),
  },

  // Quota
  getQuota: () => rest.get({ baseUrl: 'database', url: '/quota' }),
};
